export default __webpack_public_path__ + "static/media/17_tag_fitness-gym.5d9eef46.svg";